import { useState, useContext, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { Grid, Button, Dialog, DialogContent, Typography, FormHelperText } from "@mui/material";
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation } from "@apollo/client";
import { DialogTitleComp } from "../../Utils/Component";
import { SelectDatePicker } from "../Include/SelectDatePicker";
import { LOSS_OF_MEMBERSHIP } from "../../Schema/Member";
import { SelectReasonOfLossMember } from "../Include/DynamicSelect";
import moment from "moment";

export default function ResignationForm({
  open,
  editData,
  setRefetch,
  handleClose,
}) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  // const [reason, setReason] = useState({ id: "", title: "" })

  const [lossOfMembership] = useMutation(LOSS_OF_MEMBERSHIP, {
    onCompleted: ({ lossOfMembership }) => {
      setLoading(false);
      if (lossOfMembership?.isSuccess === true) {
        setAlert(true, "success", lossOfMembership?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", lossOfMembership?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });


  //fromik
  const CheckValidation = Yup.object().shape({
    reason: Yup.object().shape({
      id: Yup.string().required(t("required")),
      title: Yup.string(),
    }),
    resignDate: Yup.string().required(t("required")),
  });
 
  const formik = useFormik({
    initialValues: { 
      reason: { id: "", title: "" },
      resignDate: moment(),
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);

      const inputData = {
        reason: values?.reason?.id,
        resignDate: moment(values?.resignDate).format("YYYY-MM-DD"),
        isLossOfMembership: true,
      }

      lossOfMembership({
        variables: {
          id: editData?._id,
          input: inputData
        },
      });
    },
  });

  const {
    values,
    errors,
    touched,
    resetForm,
    handleSubmit,
    setFieldValue,
    getFieldProps,
  } = formik;

  useEffect(()=>{
    if(editData?.reason){
      setFieldValue("reason", {id: editData?.reason?._id, title: editData?.reason?.reason_title })
    }
  },[editData])

  return (
    <Dialog open={open} className="dialog-container" maxWidth="xs" fullWidth>
      <DialogTitleComp
        title={t("modal_title_loss_of_membership")}
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_resign_date")}
                </Typography>
                <SelectDatePicker
                  value={values?.resignDate}
                  onChange={(val) => setFieldValue("resignDate", val)}
                />
                {!!errors?.resignDate && touched?.resignDate && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors?.resignDate}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_reason")}
                </Typography>
                <SelectReasonOfLossMember
                  error={Boolean(touched.reason?.id && errors.reason?.id)}
                  helperText={touched.reason?.id && errors.reason?.id}
                  value={values?.reason}
                  onChange={(val) => setFieldValue("reason", val || { id: "", title: "" })}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className={t("class-btn-delete")} fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className={t("class-btn-delete")}
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {t("yes")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
